const baseURL = 'https://goloso.quickplate.cloud/';

export default baseURL;
